import Header from './components/Header';
import Hero from './components/Hero';
import LatestArchives from './components/LatestArchives';
import FlashTimeline from './components/FlashTimeline';
import HotRank from './components/HotRank';
import CategoryGrid from './components/CategoryGrid';
import Digest from './components/Digest';
import GuideCta from './components/GuideCta';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Header />
      <main>
        <Hero />
        <LatestArchives />

        {/* 快讯流 + 热度榜 双栏 */}
        <section id="flash" className="w-full border-y border-background-200 bg-background-100">
          <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
              <div className="lg:col-span-2">
                <FlashTimeline />
              </div>
              <div className="lg:col-span-1 lg:self-start lg:sticky lg:top-24">
                <HotRank />
              </div>
            </div>
          </div>
        </section>

        <CategoryGrid />
        <Digest />
        <GuideCta />
      </main>
      <Footer />
    </div>
  );
}